<ng-container *ngIf="userInfo$ | async"></ng-container>

<div class="order-documents">
  <cutting-static-documents></cutting-static-documents>
  <cutting-sys-documents [publicApiKey]="publicApiKey"></cutting-sys-documents>
  <cutting-custom-documents [publicApiKey]="publicApiKey"></cutting-custom-documents>
</div>
